import { render, staticRenderFns } from "./textIcon.vue?vue&type=template&id=315458ea&"
import script from "./textIcon.vue?vue&type=script&lang=js&"
export * from "./textIcon.vue?vue&type=script&lang=js&"
import style0 from "./textIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports